import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { WaveDeleteSvg } from './svgs';

export const IconWaveDelete: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={WaveDeleteSvg} viewBox="0 0 56 56" {...props} />;
};
